import { render, staticRenderFns } from "./CoverCandidate.vue?vue&type=template&id=3905e8bf&scoped=true"
import script from "./CoverCandidate.vue?vue&type=script&lang=js"
export * from "./CoverCandidate.vue?vue&type=script&lang=js"
import style0 from "./CoverCandidate.vue?vue&type=style&index=0&id=3905e8bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3905e8bf",
  null
  
)

export default component.exports